// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__xnSyG","label":"LabeledBox_label__N5yDk"};